<div class="receipt-footer">
  <ng-container *ngIf="branding?.footerImageUrl || branding?.footerBase64; else defaultFooter">
    <img [src]="branding?.footerBase64 || branding?.footerImageUrl" style="width: 100%; height: 100%; object-fit: contain; display: block;" alt="Custom Footer" />
  </ng-container>
  <ng-template #defaultFooter>
    <!-- Default V1 Footer (Usually empty or standard text) -->
  </ng-template>
</div>
